import { useGetAgenda } from "@/hooks/queryHooks/agendaHooks";
import { useGetMeeting } from "@/hooks/queryHooks/meetingHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { Button } from "@repo/ui/components/Base/Button";
import { useNavigate } from "react-router-dom";

export const AgendaDisplay = ({
  tenantId,
  agendaId,
}: {
  tenantId: string;
  agendaId: string;
}) => {
  const navigate = useNavigate();

  const { data: agenda } = useGetAgenda(tenantId, agendaId);
  const { data: meeting } = useGetMeeting(
    tenantId,
    agenda?.parentIds?.[0] ?? ""
  );

  const handleView = () => {
    if (!meeting?.id) return;

    const appUrlPath = new AppUrlPath(tenantId);
    navigate(appUrlPath.getMeetingPath(meeting?.id));
  };

  const handleViewAgenda = () => {
    const appUrlPath = new AppUrlPath(tenantId);
    navigate(appUrlPath.getAgendaPath(agendaId));
  };

  return (
    <div className="p-2 mb-2 bg-secondary bg-opacity-75 rounded-lg text-secondary-foreground">
      {!agenda?.template && (
        <div className="flex flex-row justify-between items-center gap-x-2">
          <h3 className="text-lg">
            {agenda && !agenda.parentIds?.[0]
              ? "No meeting used"
              : meeting?.name ?? "..."}
          </h3>
          <Button
            type="button"
            disabled={!meeting?.id}
            onClick={() => handleView()}
          >
            View
          </Button>
        </div>
      )}
      <div className="flex flex-row justify-between items-center px-2 pt-2 gap-x-2">
        <p className="text-md">
          {agenda?.template ? "Agenda Template" : "Agenda"}:{" "}
          {agenda?.name ?? "..."}
        </p>
        <Button type="button" onClick={() => handleViewAgenda()}>
          View
        </Button>
      </div>
    </div>
  );
};
